import core from "./core";

const advancementChart = [
  {
    level: 1,
    slow: { experience: 0, next: 3000 },
    medium: { experience: 0, next: 2000 },
    fast: { experience: 0, next: 1300 }
  },
  {
    level: 2,
    slow: { experience: 3000, next: 7500 },
    medium: { experience: 2000, next: 5000 },
    fast: { experience: 1300, next: 3300 }
  },
  {
    level: 3,
    slow: { experience: 7500, next: 14000 },
    medium: { experience: 5000, next: 9000 },
    fast: { experience: 3300, next: 6000 }
  },
  {
    level: 4,
    slow: { experience: 14000, next: 23000 },
    medium: { experience: 9000, next: 15000 },
    fast: { experience: 6000, next: 10000 }
  },
  {
    level: 5,
    slow: { experience: 23000, next: 35000 },
    medium: { experience: 15000, next: 23000 },
    fast: { experience: 10000, next: 15000 }
  },
  {
    level: 6,
    slow: { experience: 35000, next: 53000 },
    medium: { experience: 23000, next: 35000 },
    fast: { experience: 15000, next: 23000 }
  },
  {
    level: 7,
    slow: { experience: 53000, next: 77000 },
    medium: { experience: 35000, next: 51000 },
    fast: { experience: 23000, next: 34000 }
  },
  {
    level: 8,
    slow: { experience: 77000, next: 115000 },
    medium: { experience: 51000, next: 75000 },
    fast: { experience: 34000, next: 50000 }
  },
  {
    level: 9,
    slow: { experience: 115000, next: 160000 },
    medium: { experience: 75000, next: 105000 },
    fast: { experience: 50000, next: 71000 }
  },
  {
    level: 10,
    slow: { experience: 160000, next: 235000 },
    medium: { experience: 105000, next: 155000 },
    fast: { experience: 71000, next: 105000 }
  },
  {
    level: 11,
    slow: { experience: 235000, next: 330000 },
    medium: { experience: 155000, next: 220000 },
    fast: { experience: 105000, next: 145000 }
  },
  {
    level: 12,
    slow: { experience: 330000, next: 475000 },
    medium: { experience: 220000, next: 315000 },
    fast: { experience: 145000, next: 210000 }
  },
  {
    level: 13,
    slow: { experience: 475000, next: 665000 },
    medium: { experience: 315000, next: 445000 },
    fast: { experience: 210000, next: 295000 }
  },
  {
    level: 14,
    slow: { experience: 665000, next: 955000 },
    medium: { experience: 445000, next: 635000 },
    fast: { experience: 295000, next: 425000 }
  },
  {
    level: 15,
    slow: { experience: 955000, next: 1350000 },
    medium: { experience: 635000, next: 890000 },
    fast: { experience: 425000, next: 600000 }
  },
  {
    level: 16,
    slow: { experience: 1350000, next: 1900000 },
    medium: { experience: 890000, next: 1300000 },
    fast: { experience: 600000, next: 850000 }
  },
  {
    level: 17,
    slow: { experience: 1900000, next: 2700000 },
    medium: { experience: 1300000, next: 1800000 },
    fast: { experience: 850000, next: 1200000 }
  },
  {
    level: 18,
    slow: { experience: 2700000, next: 3850000 },
    medium: { experience: 1800000, next: 2550000 },
    fast: { experience: 1200000, next: 1700000 }
  },
  {
    level: 19,
    slow: { experience: 3850000, next: 5350000 },
    medium: { experience: 2550000, next: 3600000 },
    fast: { experience: 1700000, next: 2400000 }
  },
  {
    level: 20,
    slow: { experience: 5350000, next: 9999999 },
    medium: { experience: 3600000, next: 9999999 },
    fast: { experience: 2400000, next: 9999999 }
  }
];

const sizes = {
  Fine: { modifier: 8, fly: 8, stealth: 16 },
  Diminutive: { modifier: 4, fly: 6, stealth: 12 },
  Tiny: { modifier: 2, fly: 4, stealth: 8 },
  Small: { modifier: 1, fly: 2, stealth: 4 },
  Medium: { modifier: 0, fly: 0, stealth: 0 },
  Large: { modifier: -1, fly: -2, stealth: -4 },
  Huge: { modifier: -2, fly: -4, stealth: -8 },
  Gargantuan: { modifier: -4, fly: -6, stealth: -12 },
  Colossal: { modifier: -8, fly: -8, stealth: -16 }
};

const getAdvancement = (exp, speed = "medium") => {
  let advancement;
  advancement = advancementChart.find(
    x => x[speed].experience <= exp && x[speed].next > exp
  );
  advancement = advancement || advancementChart[0];
  return advancement;
};

const getLevel = exp => {
  let advancement = getAdvancement(exp);
  let level = advancement ? advancement.level : 0;
  return level;
};

const getDescriptor = entity => {
  let race = entity.race || "";
  let multiClass = /[0-9]+/.test(entity.class);
  let klass = entity.class || "";

  klass =
    !multiClass && klass
      ? `${klass} ${getLevel(entity.experience)}`.trim()
      : klass;

  let description =
    entity.race || klass ? `${race} ${klass}`.trim() : "Peasant";
  return description;
};

const health = payload => {
  payload = payload || {};

  if (payload.dead) {
    return "dead";
  }

  if (payload.hitPoints) {
    if (payload.hitPoints.current <= parseInt(payload.constitution) * -1) {
      return "dead";
    }

    if (payload.hitPoints.current < 1) {
      return "unconcious";
    }

    if (
      payload.hitPoints.current <=
      parseInt(payload.hitPoints.maximum, 10) / 2
    ) {
      return "bloodied";
    }

    if (
      payload.hitPoints.current > parseInt(payload.hitPoints.maximum, 10) / 2 &&
      payload.hitPoints.current < payload.hitPoints.maximum
    ) {
      return "hurt";
    }
  }

  return "full";
};

const isDead = entity => {
  let constitution = core.getAttribute("constitution", entity.attributes);

  let payload = {
    dead: entity.dead || false,
    hitPoints: {
      current: core.getTotalHitPoints(entity.hitPoints),
      maximum: entity.hitPoints.maximum
    },
    constitution: constitution.score
  };

  let status = health(payload);
  return status === "dead";
};

const getArmorClassDex = ac => {
  let armorClass = ac.armorClass;
  let dexterity = ac.dexterity;
  let base = core.getAttributeBonus(dexterity);

  if (armorClass.armor) {
    if (
      Number.isFinite(armorClass.armor.maxDex) &&
      base > armorClass.armor.maxDex
    )
      base = armorClass.armor.maxDex;
  }

  if (
    armorClass.shield &&
    Number.isFinite(armorClass.shield.maxDex) &&
    base > armorClass.shield.maxDex
  ) {
    base = armorClass.shield.maxDex;
  }

  return base;
};

const getArmorClass = ac => {
  let armorClass = ac.armorClass;
  let size = ac.size || "Medium";
  let total = 10 + getArmorClassDex(ac);

  if (armorClass.armor && Number.isFinite(armorClass.armor.bonus))
    total += armorClass.armor.bonus;
  if (
    armorClass.shield &&
    Number.isFinite(armorClass.shield.bonus) &&
    armorClass.shield.raised !== false
  )
    total += armorClass.shield.bonus;
  if (armorClass.magic && Number.isFinite(armorClass.magic.bonus))
    total += armorClass.magic.bonus;
  if (armorClass.natural && Number.isFinite(armorClass.natural.bonus))
    total += armorClass.natural.bonus;
  if (armorClass.deflection && Number.isFinite(armorClass.deflection.bonus))
    total += armorClass.deflection.bonus;
  if (armorClass.dodge && Number.isFinite(armorClass.dodge.bonus))
    total += armorClass.dodge.bonus;
  if (armorClass.misc && Number.isFinite(armorClass.misc.bonus))
    total += armorClass.misc.bonus;

  total += sizes[size].modifier;

  return total;
};

const getArmorClassTouch = ac => {
  let armorClass = ac.armorClass;
  let size = ac.size || "Medium";
  let total = 10 + getArmorClassDex(ac);

  if (armorClass.magic && Number.isFinite(armorClass.magic.bonus))
    total += armorClass.magic.bonus;
  if (armorClass.deflection && Number.isFinite(armorClass.deflection.bonus))
    total += armorClass.deflection.bonus;
  if (armorClass.dodge && Number.isFinite(armorClass.dodge.bonus))
    total += armorClass.dodge.bonus;
  if (armorClass.misc && Number.isFinite(armorClass.misc.bonus))
    total += armorClass.misc.bonus;

  total += sizes[size].modifier;

  return total;
};

const getArmorClassFlatFooted = ac => {
  let armorClass = ac.armorClass;
  let size = ac.size || "Medium";
  let total = 10;

  if (armorClass.armor && Number.isFinite(armorClass.armor.bonus))
    total += armorClass.armor.bonus;
  if (armorClass.shield && Number.isFinite(armorClass.shield.bonus))
    total += armorClass.shield.bonus;
  if (armorClass.magic && Number.isFinite(armorClass.magic.bonus))
    total += armorClass.magic.bonus;
  if (armorClass.natural && Number.isFinite(armorClass.natural.bonus))
    total += armorClass.natural.bonus;
  if (armorClass.deflection && Number.isFinite(armorClass.deflection.bonus))
    total += armorClass.deflection.bonus;
  if (armorClass.misc && Number.isFinite(armorClass.misc.bonus))
    total += armorClass.misc.bonus;

  total += sizes[size].modifier;

  return total;
};

const getAttackBonus = payload => {
  let attack = payload.item.attack;
  let attribute = payload.attribute;
  let size = payload.size;

  let bonus = attribute ? core.getAttributeBonus(attribute) : 0;

  if (payload.item.proficient && payload.baseAttackBonus)
    bonus += payload.baseAttackBonus;

  if (attack.misc && isFinite(attack.misc)) bonus += parseInt(attack.misc, 10);
  if (attack.magic && isFinite(attack.magic))
    bonus += parseInt(attack.magic, 10);
  if (size) bonus += sizes[size].modifier;

  return bonus;
};

const getDamageBonus = payload => {
  let damage = payload.damage;
  let attribute = payload.attribute;

  if (damage) {
    let bonus = 0;
    bonus += attribute ? core.getAttributeBonus(attribute) : 0;

    bonus +=
      damage.misc && isFinite(damage.misc) ? parseInt(damage.misc, 10) : 0;

    bonus +=
      damage.magic && isFinite(damage.magic) ? parseInt(damage.magic, 10) : 0;

    return bonus;
  }
};

const getCarriedWeight = items => {
  let itemWeights = [];
  items.filter(x => x.carried).forEach(item => {
    let quantity = item.quantity && isFinite(item.quantity) ? item.quantity : 0;
    let weight = item.quantity && isFinite(item.weight) ? item.weight : 0;
    if (quantity > 0 && weight > 0) itemWeights.push(quantity * weight);
  });
  var totalWeight = itemWeights.reduce((prevVal, val) => {
    return parseFloat(prevVal) + parseFloat(val);
  }, 0);

  let fixedFloat = totalWeight.toFixed(1);
  fixedFloat = fixedFloat.endsWith(".0")
    ? fixedFloat.replace(".0", "")
    : fixedFloat;
  return fixedFloat;
};

const getActionTypes = () => {
  let actionTypes = core.actionTypes;
  return actionTypes;
};

const getItemTypes = () => {
  let itemTypes = core.itemTypes;
  return itemTypes;
};

const ruleset = {
  getLevel: getLevel,
  getDescriptor: getDescriptor,
  getArmorClass: getArmorClass,
  getArmorClassDex: getArmorClassDex,
  getArmorClassTouch: getArmorClassTouch,
  getArmorClassFlatFooted: getArmorClassFlatFooted,
  getAttackBonus: getAttackBonus,
  getDamageBonus: getDamageBonus,
  getCarriedWeight: getCarriedWeight,

  getActionTypes: getActionTypes,
  getItemTypes: getItemTypes,

  getAttribute: core.getAttribute,
  getAttributeBonus: core.getAttributeBonus,
  getTotalHitPoints: core.getTotalHitPoints,
  attributeOptions: core.attributeOptions,
  spellSchools: core.spellSchools,

  ruleTypes: core.ruleTypes,
  ruleTypesPlural: core.ruleTypesPlural,

  health: health,
  isDead: isDead
};

export default ruleset;
